(function () {

  'use strict';

  function pxChart() {
    return {
      restrict: 'A',
      scope: {
        chartType: '=pxChart',
        chartData: '=pxChartData',
        chartLabels: '=pxChartLabels',
        chartOptions: '=pxChartOptions'
      },
      link: function (scope, element, attrs) {

        let chartInstance = null;

        const defaultOptions = {
          elements: {
            line: {
              backgroundColor: '#ddeeff',
              borderColor: '#4499ee',
              borderWidth: 2
            },
            point: {
              backgroundColor: '#4499ee',
              borderWidth: 0,
              hitRadius: 5,
              hoverRadius: 3,
              radius: 2
            }
          },
          layout: {
            padding: 2
          },
          legend: {
            display: false
          },
          maintainAspectRatio: false,
          responsive: true,
          scales: {
            xAxes: [{
              display: false
            }],
            yAxes: [{
              display: false
            }]
          },
          tooltips: {
            displayColors: false
          }
        };

        scope.$on('$destroy', function () {
          if (chartInstance) {
            chartInstance.destroy();
            chartInstance = null;
          }
        });

        (function () {
          createChartInstance();
        })();

        function createChartInstance() {
          chartInstance = new Chart(element[0].getContext('2d'), {
            type: scope.chartType || 'line',
            data: {
              labels: scope.chartLabels || [],
              datasets: convertData(scope.chartData)
            },
            options: angular.merge({}, defaultOptions, scope.chartOptions)
          });
        }

        function convertData(data) {
          if (!angular.isArray(data)) {
            return [];
          }
          return data.map(function (dataset) {
            if (angular.isArray(dataset)) {
              return { data: dataset };
            }
            return { data: [] };
          });
        }

      }
    };
  }

  pxChart.$inject = [];

  angular
    .module('printix-admin')
    .directive('pxChart', pxChart);

})();
